export default __webpack_public_path__ + "static/media/ProductPageImage05.30e8f198.jpg";